
export enum TicketPoolStrategy {
  Legacy = 'Legacy',
  Standard = 'Standard',
  Sharded = 'Sharded',
}
